var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DatasetIndex,{staticClass:"dataset-index",attrs:{"history-dataset-id":_setup.props.args.history_dataset_id,"path":_setup.props.args.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }